module.exports = __webpack_public_path__ + "static/media/repl_start.8e14b1e9.jpg";